import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {SearchSuggestionsTrendingSkeleton} from './SearchSuggestionsTrendingSkeleton';

export const SearchSuggestionsTrending = lazy(
  () =>
    import('./SearchSuggestionsTrending.eager').then(mod => ({
      default: mod.SearchSuggestionsTrending,
    })),
  {fallback: <SearchSuggestionsTrendingSkeleton />},
);
